import React from "react";
import { CheckCircle2, XCircle, Layers, Sparkles } from "lucide-react";

export default function PlanApprovalCard({ plan, onApprove, onReject, disabled }) {
  if (!plan) return null;
  return (
    <div
      data-testid="omnicraft-plan-card"
      className="rounded-xl border border-emerald-500/30 bg-emerald-500/[0.06] p-4 space-y-3"
    >
      <div className="flex items-center gap-2 text-emerald-300 text-xs uppercase tracking-wider">
        <Sparkles size={12} /> Build Plan Review
      </div>
      <div className="text-white/90 text-sm leading-relaxed">{plan.summary}</div>

      {plan.affectedFiles?.length > 0 && (
        <div>
          <div className="text-[10px] uppercase text-white/40 mb-1">Files</div>
          <div className="space-y-1">
            {plan.affectedFiles.map((f, i) => (
              <div
                key={i}
                className="flex items-center gap-2 text-xs font-mono text-white/80"
              >
                <span
                  className={`px-1.5 py-0.5 rounded text-[10px] uppercase ${
                    f.action === "create"
                      ? "bg-emerald-500/20 text-emerald-300"
                      : f.action === "delete"
                      ? "bg-rose-500/20 text-rose-300"
                      : "bg-amber-500/20 text-amber-300"
                  }`}
                >
                  {f.action}
                </span>
                <span className="truncate flex-1">{f.path}</span>
                {f.reason && <span className="text-white/40 truncate">{f.reason}</span>}
              </div>
            ))}
          </div>
        </div>
      )}

      {plan.dependenciesToAdd?.length > 0 && (
        <div>
          <div className="text-[10px] uppercase text-white/40 mb-1">Dependencies</div>
          <div className="flex flex-wrap gap-1.5">
            {plan.dependenciesToAdd.map((d) => (
              <span
                key={d}
                className="px-2 py-0.5 rounded-full bg-white/5 text-[11px] text-white/70 border border-white/10"
              >
                {d}
              </span>
            ))}
          </div>
        </div>
      )}

      {plan.clarifications?.length > 0 && (
        <div className="space-y-2">
          <div className="text-[10px] uppercase text-white/40">Clarifications</div>
          {plan.clarifications.map((c, i) => (
            <div key={i} className="text-xs text-white/70">
              <div className="text-white/90 mb-1">{c.question}</div>
              <div className="flex flex-wrap gap-1.5">
                {(c.options || []).map((opt) => (
                  <span
                    key={opt}
                    className="px-2 py-1 rounded-md border border-white/10 bg-white/[0.03] text-white/70"
                  >
                    {opt}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="flex items-center gap-2 pt-1">
        <button
          data-testid="omnicraft-plan-approve"
          disabled={disabled}
          onClick={onApprove}
          className="flex-1 py-2 rounded-md bg-emerald-500 text-black text-xs font-semibold uppercase tracking-wider flex items-center justify-center gap-2 hover:bg-emerald-400 disabled:opacity-40"
        >
          <CheckCircle2 size={14} /> Approve &amp; Build
        </button>
        <button
          data-testid="omnicraft-plan-reject"
          disabled={disabled}
          onClick={onReject}
          className="px-4 py-2 rounded-md border border-white/10 text-xs text-white/70 flex items-center gap-2 hover:bg-white/[0.04] disabled:opacity-40"
        >
          <XCircle size={14} /> Refine
        </button>
      </div>
    </div>
  );
}
